import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';
import { LinkButton } from '../Button';

export const StyledFeedbackLink = styled(LinkButton)`
  color: #fff;
  position: fixed;
  text-decoration: none;
  bottom: 35rem;
  right: 0;
  transition: transform 0.2s ease-in-out;
  transform-origin: bottom right;
  z-index: 5;
  letter-spacing: 0.01em;
  transform: rotate(-90deg) translateY(${tvar('space.x1')});
  padding: ${tvar('space.x1')} ${tvar('space.x2')} ${tvar('space.x2')};
  font-size: ${tvar('typographies.h3.fontSize')};
  background: ${tvar('colors.brand.primary')};

  &:hover {
    transform: rotate(-90deg) translateY(0);
  }
`;
